export default {
  labels: {
    today: 'Today',
    pickup_time: 'Pickup time',
    on_site_time: 'Serve time',
    delivery_time: 'Delivery time',
  },
};
